export default __webpack_public_path__ + "static/media/main_item_03.2e16deb7.png";